import React, { useEffect } from 'react'

const SearchBox = ({nameOfClass, screenSize='desktop'}) => {
    useEffect(() => {
        const script=document.createElement('script')
        script.src="https://cse.google.com/cse.js?cx=009164658937669078311:jk1fdjafiky"
        script.defer=true;
        script.type = "text/javascript";
        document.querySelector('#searchScript')?.appendChild(script)
      return () => {
     
      }
    }, [])
    return(
                <section id='searchScript' className={nameOfClass}>
                    { screenSize==='desktop' ? <h4>Search</h4> : ''}
                    <div className="gcse-searchbox-only" data-resultsurl='/search-results' enableautocomplete="true"></div>
                </section> 
    )
}

export default SearchBox
